import {
  ExchangeRecommendationsSchema,
  GenerateExchangeRecommendationsInputSchema,
} from "@redotech/redo-model/agents/returns-agents/exchange-recommendations";

export const getSimpleFallbackExchangeRecommendations = {
  name: "getSimpleFallbackExchangeRecommendations" as const,
  input: GenerateExchangeRecommendationsInputSchema,
  output: ExchangeRecommendationsSchema,
};
